import { render, staticRenderFns } from "./ServiceSlider.vue?vue&type=template&id=6200ca06&scoped=true"
import script from "./ServiceSlider.vue?vue&type=script&lang=js"
export * from "./ServiceSlider.vue?vue&type=script&lang=js"
import style0 from "./ServiceSlider.vue?vue&type=style&index=0&id=6200ca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6200ca06",
  null
  
)

export default component.exports